import * as d3 from 'd3';
import { GetQuoteChartQueryParamIntervalDto } from 'src/dtos';

export const mapQueryParamIntervalDtoToChartOptions = (interval: GetQuoteChartQueryParamIntervalDto) => {
  switch (interval) {
    case GetQuoteChartQueryParamIntervalDto.OneDay:
      return {
        xAxis: {
          tickInterval: d3.timeHour,
          tickStep: 2,
          tickFormat: 'HH:mm',
        },
      };
    case GetQuoteChartQueryParamIntervalDto.OneWeek:
      return {
        xAxis: {
          tickInterval: d3.timeDay,
          tickStep: 1,
          tickFormat: 'dddd',
        },
      };
    case GetQuoteChartQueryParamIntervalDto.OneMonth:
      return {
        xAxis: {
          tickInterval: d3.timeWeek,
          tickStep: 1,
          tickFormat: 'Do MMM',
        },
      };
    case GetQuoteChartQueryParamIntervalDto.SixMonths:
      return {
        xAxis: {
          tickInterval: d3.timeMonth,
          tickStep: 1,
          tickFormat: 'MMM YYYY',
        },
      };
    case GetQuoteChartQueryParamIntervalDto.OneYear:
      return {
        xAxis: {
          tickInterval: d3.timeMonth,
          tickStep: 2,
          tickFormat: 'MMM YYYY',
        },
      };
    case GetQuoteChartQueryParamIntervalDto.All:
      return {
        xAxis: {
          tickInterval: d3.timeYear,
          tickStep: 1,
          tickFormat: 'YYYY',
        },
      };
  }
};
